import updateTree from './updateTree'
import { setSessionToken } from 'api'

export default function facebookAuth(state = {}, action) {
  switch (action.type) {

    case 'SET_USER': {
      if (!window.location.pathname.startsWith("/webview") && !action.ephemeral) {
        localStorage.setItem('user', JSON.stringify(action.user))
      }
      return updateTree(state, 'user', () => action.user)
    }

    default:
      if (state.user && state.user.session_token) {
        setSessionToken(state.user.session_token)
      }
      return {
        user: null,
        ...state
      }
  }
}